import { ShellContainerConfig } from '@appd/fso-ui-shell/container';
import { getFlagValue } from '@appd/fso-ui-shell/feature-flags';
import { config } from '../../appConfig';
import { FEATURE_FLAGS_STORE_KEY } from '../core/constants';
import { LiveNewsDrawer } from './LiveNewsDrawer/LiveNewsDrawer';

export const getShellTopNavConfig = (dashboardName: string, hideTimeRangeSelector: boolean): ShellContainerConfig => ({
  topNav: {
    leftPlugins: [],
    rightPlugins: [
      {
        name: 'display',
        visible: dashboardName === 'paris2024',
        style: {
          order: -1,
        },
        props: {
          component: <LiveNewsDrawer />,
        },
      },
      {
        name: 'timeRangeV2',
        visible:
          dashboardName?.length > 0 &&
          !hideTimeRangeSelector &&
          !getFlagValue(FEATURE_FLAGS_STORE_KEY, 'ENABLE_ADVANCED_DASHIFY_EDITOR'),
        props: {
          useStateTimeRange: true,
        },
      },
      {
        name: 'shareButton',
        visible: true,
      },
      {
        name: 'helpCenter',
        visible: true,
        props: {
          disabled: false,
          productVersion: config.NEXT_PUBLIC_VERSION,
        },
      },
      {
        name: 'miniProfile',
        visible: true,
        props: {
          accountsLaunchUrl: config.NEXT_PUBLIC_ACCOUNTS_LAUNCH_URL,
          accountsManageProfileUrl: config.NEXT_PUBLIC_ACCOUNTS_MANAGE_PROFILE_URL,
          accountsOverviewUrl: config.NEXT_PUBLIC_ACCOUNTS_OVERVIEW_URL,
          accountsViewAllUrl: config.NEXT_PUBLIC_ACCOUNTS_VIEW_ALL_URL,
          cloudTenantApiUrl: config.NEXT_PUBLIC_CLOUD_TENANT_API_URL,
          communityUrl: config.NEXT_PUBLIC_COMMUNITY_URL,
          helpUrl: config.NEXT_PUBLIC_HELP_URL,
          identityApiUrl: config.NEXT_PUBLIC_IDENTITY_API_URL,
          logoutUrl: config.NEXT_PUBLIC_LOGOUT_URL,
          saasTenantApiUrl: config.NEXT_PUBLIC_SAAS_TENANT_API_URL,
          universityUrl: config.NEXT_PUBLIC_UNIVERSITY_URL,
        },
      },
    ],
  },
});
